import React, { useState, Context, ReactElement, Component } from "react";

export interface podRestartAlarm_type {
    kind: string;
    items: podRestartAlarm_type_item[];
}

export interface podRestartAlarm_type_item {
    metadata: {
        name: string;
        namespace: string;
        selfLink: string;
        uid: string;
        resourceVersion: string;
        generation: number;
        creationTimestamp: string;
        labels?: object;
        annotations?: object;
    };

    spec: {
        namespace: string;
        podname: string;
        container: string;
        type: string;
        creationTimestamp: string | number;
        updateTimeStamp: string | number;
        prelog: any;
        afterlog:any
    };
    status?: object;
}

export interface podEvent_type_item {
    name: string;
    container: string;
    type: string;
    updateTime: string;
    restartLog: {
        prelog: any;
        afterlog:any;
    }
}

const PodRestartAlarmContext: Context<[podRestartAlarm_type_item[] | undefined, React.Dispatch<React.SetStateAction<podRestartAlarm_type_item[] | undefined>>]> = React.createContext<[podRestartAlarm_type_item[] | undefined, React.Dispatch<React.SetStateAction<podRestartAlarm_type_item[] | undefined>>]>([undefined, (_value: any) => { }]);

const PodRestartAlarmProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [podRestartAlarm, set_podRestartAlarm]: [podRestartAlarm_type_item[] | undefined, React.Dispatch<React.SetStateAction<podRestartAlarm_type_item[] | undefined>>] = useState();
    return (
        <PodRestartAlarmContext.Provider value={[podRestartAlarm, set_podRestartAlarm]}>
            {props.children}
        </PodRestartAlarmContext.Provider>
    )
}

export { PodRestartAlarmContext, PodRestartAlarmProvider };

